import React from 'react';
import HeroImg from '../../Images/Redesign/hero.png';
import { HiCheck, HiOutlineSparkles, HiOutlineShieldCheck, HiArrowRight } from 'react-icons/hi';

import { Highlighter } from '../Highlighter/Highlighter';

function MainHomeContainer() {
    return (
        <section className="relative min-h-screen flex items-center pt-28 pb-20 overflow-hidden bg-secondary">
            {/* Architectural Background Elements */}
            <div className="absolute top-0 right-0 w-1/2 h-full bg-primary/[0.03] skew-x-12 translate-x-1/4 -z-10"></div>
            <div className="absolute top-1/4 left-10 w-96 h-96 bg-primary/5 rounded-full blur-[120px] -z-10 animate-pulse"></div>
            
            <div className="container-custom grid lg:grid-cols-2 gap-16 items-center">
                {/* Content Side */}
                <div className="space-y-10 text-center lg:text-left relative z-10">
                    <div className="inline-flex items-center gap-3 px-6 py-2.5 rounded-full bg-white shadow-sm border border-border/50 text-foreground font-black text-[10px] uppercase tracking-[0.2em]">
                        <span className="flex text-primary">
                            <HiOutlineSparkles size={14} className="animate-spin-slow" />
                        </span>
                        The Gold Standard of Clean
                    </div>
                    
                    <h1 className="text-6xl md:text-7xl lg:text-[5.5rem] font-heading font-black leading-[0.95] text-foreground tracking-tighter">
                        Immaculate <br /> 
                        <span className="text-primary italic">Spaces</span> <br />
                        <Highlighter action="underline" color="#ffc107" strokeWidth={2} iterations={3} animationDuration={400}>
                            Pure Luxury
                        </Highlighter>
                    </h1>
                    
                    <p className="text-xl text-muted-foreground leading-relaxed max-w-xl mx-auto lg:mx-0 font-medium">
                        Elevate your lifestyle with AstraClean's clinical-grade sanitation and hospitality-driven approach to every corner of your home.
                    </p>
                    
                    <div className="flex flex-col sm:flex-row items-center gap-6 justify-center lg:justify-start">
                        <a href="#MainHome-services-container" className="btn-primary !px-10 !py-5 flex items-center gap-3 uppercase tracking-[0.2em] text-xs font-black">
                            Explore Services
                            <HiArrowRight size={16} />
                        </a>
                        <button className="text-foreground font-black uppercase tracking-[0.2em] text-xs flex items-center gap-2">
                            Our Methodology
                            <span className="w-8 h-px bg-foreground"></span>
                        </button>
                    </div>

                    {/* Trust Indicators */}
                    <div className="pt-10 flex flex-wrap items-center justify-center lg:justify-start gap-x-10 gap-y-6 opacity-60">
                        <div className="flex items-center gap-2">
                            <HiCheck className="text-primary" />
                            <span className="text-[10px] font-black uppercase tracking-widest text-foreground">Eco-Certified</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <HiCheck className="text-primary" />
                            <span className="text-[10px] font-black uppercase tracking-widest text-foreground">Verified Pros</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <HiCheck className="text-primary" />
                            <span className="text-[10px] font-black uppercase tracking-widest text-foreground">Full Insurance</span>
                        </div>
                    </div>
                </div>

                {/* Visual Side */}
                <div className="relative hidden lg:block">
                    {/* Main Image Mask */}
                    <div className="relative z-10">
                        <img 
                            src={HeroImg} 
                            alt="Modern Cleaning Service" 
                            className="w-full h-full object-cover rounded-l-[100px] shadow-2xl"
                        />
                    </div>

                    {/* Decorative Geometric */}
                    <div className="absolute -top-10 left-1/4 w-32 h-32 border-2 border-primary/20 rounded-full -z-10 animate-spin-slow"></div>
                    <div className="absolute inset-0 bg-primary/5 rounded-[4rem] rotate-6 -z-20"></div>
                </div>
            </div>
            
            {/* Scroll Indicator */}
            <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-30">
                <span className="text-[10px] font-black uppercase tracking-[0.3em]">Scroll</span>
                <div className="w-px h-12 bg-gradient-to-b from-foreground to-transparent"></div>
            </div>
        </section>
    );
}

export default MainHomeContainer;


